import React from "react";
import { Icon } from "./Icon";
export const IconChevronUp = (props) => (
  <Icon {...props}>
    <path d="M18 15l-6-6-6 6" />
  </Icon>
);
